const TabItems = ({ item, selected, setSelected }) => {
  const handleSelect = (e) => {
    e.preventDefault();
    setSelected(e.target.value);
  };
  return (
    <li
      className="group relative w-1/3   border-r border-indigo-900 "
      key={item.id}  
    >
      <button
        key={item.id}
        onClick={handleSelect}
        data-selected={selected === item?.id}
        className="group whitespace-nowrap w-full text-gray-300 dark:text-indigo-100 text-center inline-flex items-center py-2 px-4  data-[selected=true]:bg-indigo-500  data-[selected=false]: bg-indigo-600 "
        value={item?.id}
      >
        {item.name}
      </button>
    </li>
  );
};

export default TabItems;
